"use client";

import Image from "next/image";
import dynamic from "next/dynamic";
import { memo } from "react";
import StickyNav from "./sticky-nav";
import SiteFooter from "./site-footer";
import HeroBanner from "./hero-banner";

// Lazy load all below-fold sections to reduce main thread work
const TradingPlatformSection = dynamic(() => import("./trading-platform-section"), {
  loading: () => <div className="min-h-[400px]" />,
});
const TechSection = dynamic(() => import("./tech-section"), {
  loading: () => <div className="min-h-[400px]" />,
});
const RoadmapSection = dynamic(() => import("./roadmap-section"), {
  loading: () => <div className="min-h-[400px]" />,
});
const MobileSection = dynamic(() => import("./mobile-section"), {
  loading: () => <div className="min-h-[400px]" />,
});
const BigSloganSection = dynamic(() => import("./big-slogan-section"), {
  loading: () => <div className="min-h-[200px]" />,
  ssr: false, // Disable SSR since it contains Spline 3D scene
});

const HomeDefault = memo(function HomeDefault() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[color:var(--background)] text-[color:var(--text-primary)]">
      <StickyNav />
      <main className="relative z-20 flex flex-col bg-[#030303]">
        <HeroBanner />
        <div className="relative z-20  w-full h-full border-t-2 border-t-[var(--field-border)] rounded-t-[30px] md:rounded-t-[40px] lg:rounded-t-[50px] mt-[95vh] sm:mt-[85vh] md:mt-[100vh] bg-[#030303] overflow-hidden">
          {/* Radial gradient at the top */}
          <div className="absolute top-0 left-0 right-0 pointer-events-none">
              <Image
              src="/assets/radio-top.svg"
                alt="Decorative gradient background"
              width={2153}
              height={445}
              className="w-full h-full object-cover"
              />
          </div>
          <TradingPlatformSection />  
          <MobileSection />
          <TechSection />
          <RoadmapSection />
          <BigSloganSection />
        </div>
        <SiteFooter />
      </main>
    </div>
  );
});

export default HomeDefault;
